export const zigTags = {
	title: "Gerenciar Zig Tags",
	table: {
		columns: {
			zigCode: "Zig Code",
			userName: "Usuário",
			userDocument: "Documento do usuário",
			isBlocked: "Está bloqueada?",
			actions: "Ações",
		},
		actions: {
			blockTag: "Bloquear Tag",
		},
	},
	form: {
		label: "Buscar Zig Tag",
		placeholder: "Digite o número da tag",
		searchBtn: "Buscar",
		errors: {
			zigTagRequired: "Digite o número da tag para buscar",
		},
	},
	empty: {
		title: "Busque uma zig tag para gerenciá-la",
	},
	block: {
		success: "Tag bloqueada com sucesso",
	},
};
